<template>
  <svg width="100%" height="320px" :ref="departamentoSlug" :id="departamentoSlug" class="plan-vector-map">
    <g ref="base"></g>
    <g ref="features"></g>
  </svg>
</template>

<script>
  import * as d3 from 'd3'
  import { feature } from 'topojson'

  export default {
    name: "MapaDepartamento",
    props: {
      departamento: {}
    },
    data() {
      return {
        width: 320
      }
    },
    mounted() {
      this.renderMapa()
    },
    computed: {
      projection () {
        return d3.geoMercator()
          .translate([this.width/2, this.width/2])
          .scale(1500)
      },
      path () {
        return d3.geoPath().projection(this.projection)
      },
      departamentoSlug() {
        return this.departamento.nombre.replace(" ","_").toLowerCase().replace(" ","_")
      },
      peru() {
        return require(`../data/mapas/peru.json`)
      },
      geodata() {
        return require(`../data/mapas/${this.departamentoSlug}.json`)
      }
    },
    methods: {
      renderMapa() {
        let distritosFeatures = feature(this.geodata, this.geodata.objects[this.departamentoSlug])
        
        let base = d3.select(this.$refs['base'])
        let featuresGroup = d3.select(this.$refs['features'])

        let bounds = d3.geoBounds(distritosFeatures),
            center = d3.geoCentroid(distritosFeatures)

        // Compute the angular distance between bound corners
        let distance = d3.geoDistance(bounds[0], bounds[1]),
            scale = this.width / distance / Math.sqrt(1)

        this.projection
          .translate([this.width/2, this.width/2])
          .center(center)
          .scale(scale)

        featuresGroup.selectAll('path')
          .data(distritosFeatures.features)
          .enter()
          .append('path')
          .attr('d',this.path)
          .attr('class', distrito => {
            if(this.departamento.distritos.includes(distrito.properties.DISTRITO)) {
              return `distrito-path distrito-selected`
            }
            return `distrito-path`
          })

        base.selectAll('path')
          .data(this.peru.features)
          .enter()
          .append('path')
          .attr('d',this.path)
          .attr('class', dep => {
            return `departamento-path ${dep}-path`
          })


        return 
      }
    }
  }

</script>

<style>
  svg.plan-vector-map {
    background: #f1f1f1;
  }
  .distrito-path {
    fill: #91ad8d;
    stroke: #ffffff21;
    stroke-width: 1px;
  }

  .departamento-path {
    fill: #eaeaea;
    stroke: #66755d;
    stroke-width: 1px;
  }

  .distrito-selected {
    fill: #b55353;
  }

  .departamento-map {
    width: 100%;
  }
</style>